export const isNotUndefinedArray = <T>(test: T[] | undefined): T[] =>
  test ? test : []

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ifDevElse = (whenDev: () => any, whenNotDev: () => any) =>
  process.env.NODE_ENV === 'development' ? whenDev() : whenNotDev()

export const hashString = (s: string) =>
  s.split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0)

export const ifArrayReturnNthItem = <T>(
  a: T,
  nthItem = 1,
): (T extends (infer R)[] ? R : T) | undefined =>
  Array.isArray(a) && a.length >= nthItem ? a[nthItem - 1] : undefined

/**
 * Calls a function with the value if it is not undefined, returns undefined or user specified value if it is
 * @param value - The value to check
 * @param fn - The function to call with the defined value
 * @param valueIfUndefined - The value to return if the value is undefined
 */
export const ifValue = <
  T,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Fn extends (args: T) => any,
  ValueIfUndefined = undefined
>(
  value: T | undefined,
  fn: Fn,
  valueIfUndefined?: ValueIfUndefined,
): ReturnType<Fn> | ValueIfUndefined => (value ? fn(value) : valueIfUndefined)
